import React from 'react';
import { Datetime, DatetimeProps } from '@fx-ui/fine-design';

interface MemberFieldDatetimeProps extends Omit<DatetimeProps, 'onChange'> {
    onChange?: (value: number | null) => void;
}

const MemberFieldDatetime: React.FC<MemberFieldDatetimeProps> = (props) => {
    const { onChange, ...otherProps } = props;

    return (
        <Datetime
            onChange={(dayjsValue) => {
                onChange?.(dayjsValue ? dayjsValue.valueOf() : null);
            }}
            {...otherProps}
        />
    );
};

export default MemberFieldDatetime;
